import React, { useContext, useEffect, useRef } from 'react';
import { Box, Button, ChatHeader, Flex, Text } from 'pcln-design-system';
import { ChatbotDataContext } from '../context/ChatbotDataContext';
var LivePersonCloseChatModalContents = function (props) {
    var closeModalHeaderRef = useRef(null);
    var setCloseLpChat = useContext(ChatbotDataContext).setCloseLpChat;
    useEffect(function () {
        // Todo This should be removed as soon as DS updates the ChatHeader to accept props to add the flexibility to hide or display the minimize Button.
        closeModalHeaderRef.current.querySelectorAll('button')[0].style.display = 'none';
    }, []);
    function handleCancelAction() {
        props.onClose(false);
    }
    function handleEndChatAction() {
        setCloseLpChat(true);
        props.onClose(false);
    }
    return (React.createElement(Box, { ref: closeModalHeaderRef },
        React.createElement(ChatHeader, { onClose: handleCancelAction, onMinimize: handleCancelAction },
            React.createElement(Text, { bold: true }, "End Chat")),
        React.createElement(Text, { fontSize: 2, p: 3 }, "Are you sure you want to end this chat?"),
        React.createElement(Flex, { alignItems: 'left', p: 3, pt: 0 },
            React.createElement(Button, { variation: 'subtle', mr: 3, onClick: handleCancelAction }, "Cancel"),
            React.createElement(Button, { onClick: handleEndChatAction }, "End Chat"))));
};
export default LivePersonCloseChatModalContents;
//# sourceMappingURL=LivePersonCloseChatModal.js.map